"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _ButtonIcon = require("./ButtonIcon.types");
require("./ButtonIcon.scss");
var _excluded = ["icon", "className", "size"];
var ButtonIcon = function ButtonIcon(_ref) {
  var icon = _ref.icon,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _ButtonIcon.BUTTON_ICON_SIZE["default"] : _ref$size,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var rootClassName = (0, _classnames["default"])('cds-ButtonIcon', (0, _defineProperty2["default"])({}, "cds-ButtonIcon--".concat((0, _upperCaseFirst.upperCaseFirst)(size || '')), size !== _ButtonIcon.BUTTON_ICON_SIZE["default"]), className);
  return /*#__PURE__*/_react["default"].createElement(_Button.Button, (0, _extends2["default"])({}, props, {
    size: _Button.BUTTON_SIZE["default"],
    className: rootClassName
  }), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: icon,
    className: "cds-ButtonIcon-Icon"
  }));
};
exports.ButtonIcon = ButtonIcon;